import patterns from '../web-sh/src/config/patterns';

export default {
  ...patterns,
  LETTERS_AND_NUMBER: /^[a-zA-Z0-9]*$/,
  ALIAS: /^[a-z0-9]+(-[a-z0-9]+)*$/,
  WHITELIST_URL: /^(https?:\/\/)(?:[a-zA-Z0-9.-]+|\d{1,3}(?:\.\d{1,3}){3})(?::\d+)?(?:\/.*)?$/,
  FACEBOOK_PROFILE_URL: /^https?:\/\/(www\.)?facebook\.com\/((profile\.php\?id=\d+)|([a-zA-Z0-9.]+)|(groups\/[a-zA-Z0-9.]+)|(events\/[a-zA-Z0-9.]+))\/?$/
}